import { getApiInstance } from './api.helpers';
const makeApiCall = async ({ method = 'get', path, payload, params, environment, webApi, onError, }) => {
    let response;
    try {
        if (!!environment) {
            const apiInstance = getApiInstance(environment);
            if (method === 'get') {
                response = await apiInstance.get(path, { params });
            }
            else if (method === 'post') {
                response = await apiInstance.post(path, payload, { params });
            }
        }
        else if (!!webApi) {
            if (method === 'get') {
                response = await webApi.get(path, { params });
            }
            else if (method === 'post') {
                response = await webApi.post(path, payload, { params });
            }
        }
        return response?.data || {};
    }
    catch (error) {
        if (onError) {
            onError(error);
        }
    }
};
export const getPIOversightList = async ({ environment, params, onError, }) => {
    return await makeApiCall({
        method: 'get',
        path: '/v2/routes/pi_oversight/list_participants',
        params,
        environment,
        onError,
    });
};
export const getPIOversightReviewBundle = async ({ environment, params, onError, }) => {
    return await makeApiCall({
        method: 'get',
        path: '/v2/routes/pi_oversight/get_review_bundle',
        params,
        environment,
        onError,
    });
};
export const getPIOversightSummary = async ({ webApi, payload, onError, }) => {
    return await makeApiCall({
        method: 'post',
        path: '/api/generative/pi_oversight/summary',
        payload,
        webApi,
        onError,
    });
};
export const getActivityTaskResponses = (responses) => {
    const activityResponses = [];
    const groupedResponsesByKey = responses.reduce((acc, response) => {
        const key = response.taskResponseId;
        acc[key] = [...(acc[key] || []), response];
        return acc;
    }, {});
    Object.values(groupedResponsesByKey).forEach((responses) => {
        activityResponses.push({
            activity: responses[0]?.activity ?? '',
            taskResponseCompletedDate: responses[0]?.taskResponseCompletedDate,
            taskResponseId: responses[0]?.taskResponseId ?? '',
            responses,
        });
    });
    return activityResponses.sort((a, b) => {
        const aTime = Date.parse(a.taskResponseCompletedDate || '') || 0;
        const bTime = Date.parse(b.taskResponseCompletedDate || '') || 0;
        return bTime - aTime;
    });
};
export const signOffPIOversight = async ({ environment, payload, onError, }) => {
    return await makeApiCall({
        method: 'post',
        path: '/v2/routes/pi_oversight/sign',
        payload,
        environment,
        onError,
    });
};
